export type ParticipantIdentity = {
  name: string;
  participantUserId?: string | null;
};

export const normalizeParticipantName = (name: string) =>
  name.trim().replace(/\s+/g, " ").toLocaleLowerCase("pt-BR");

/**
 * Extra não se repete: mesmo `participantUserId` **ou** o mesmo nome
 * (normalizado) já presente — inclusive o responsável.
 */
export const isDuplicateParticipant = (
  next: ParticipantIdentity,
  existing: ParticipantIdentity[],
) => {
  if (
    next.participantUserId &&
    existing.some((item) => item.participantUserId === next.participantUserId)
  ) {
    return true;
  }

  const normalized = normalizeParticipantName(next.name);
  if (!normalized) return false;

  return existing.some(
    (item) => normalizeParticipantName(item.name) === normalized,
  );
};
